import { useMemo } from 'react';

import { useIntl } from 'react-intl';
import { useRouteStationServicesFilterContext } from '../context';

import { STATION_SERVICE_PRICE_TYPES } from '../constants';

export const usePriceTitle = () => {
  const { formatMessage } = useIntl();
  const { activeStationsServicesPrice } = useRouteStationServicesFilterContext();

  const priceTitle = useMemo(() => ({
    [STATION_SERVICE_PRICE_TYPES.inCountry]: formatMessage({ id: 'priceInCountryCurrency' }),
    [STATION_SERVICE_PRICE_TYPES.inEUR]: formatMessage({ id: 'priceInEUR' })
  }[activeStationsServicesPrice] || ''), [
    formatMessage,
    activeStationsServicesPrice
  ]);

  return priceTitle;
};
